export const FILTERS_PATH_NEW = '/filters/new';
export const FILTERS_PATH_EDIT = '/filters/:id/edit';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/FiltersForm/constants.js